export default class Dictionary {
    public Id = 0;
    public Name = '';
    constructor (row: Dictionary | null = null) {
        if (row) {
            this.Id = row.Id;
            this.Name = row.Name;
        }
    }
}